import React, { createContext, useState, useRef } from "react";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const [showExitModal, setShowExitModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");
  const [exitNoreferrer, setExitNoreferrer] = useState(false);
  const [isiDrawer1Open, setIsiDrawer1Open] = useState(false);
  const [isiDrawer2Open, setIsiDrawer2Open] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const headerRef = useRef(null);

  const setHeaderVisible = (visible) => {
    setIsHeaderVisible(visible);
  };

  const openIsiDrawer1 = () => {
    setIsiDrawer1Open(true);
    setIsiDrawer2Open(false);
  };

  const closeIsiDrawer1 = () => {
    setIsiDrawer1Open(false);
  };

  const openIsiDrawer2 = () => {
    setIsiDrawer2Open(true);
    setIsiDrawer1Open(false);
  };

  const closeIsiDrawer2 = () => {
    setIsiDrawer2Open(false);
  };

  const openExitModal = (url, exitNoreferrer) => {
    setExitUrl(url);
    setExitNoreferrer(exitNoreferrer);
    setShowExitModal(true);
  };

  const closeExitModal = () => {
    setShowExitModal(false);

    // bug fix: prevent the modal from closing before the exit URL is opened
    // without this, the exit url clears too fast, and the browser opens a tab with the same url instead of the exit one
    setTimeout(() => {
      setExitUrl("");
      setExitNoreferrer(false);
    }, 100);
  };

  const store = {
    showExitModal,
    exitUrl,
    exitNoreferrer,
    openExitModal,
    closeExitModal,
    isiDrawer1Open,
    openIsiDrawer1,
    closeIsiDrawer1,
    isiDrawer2Open,
    openIsiDrawer2,
    closeIsiDrawer2,
    headerRef,
    isHeaderVisible,
    setHeaderVisible,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
